import { createGlobalState } from 'react-hooks-global-state';

const initialState = {
    unisatWallet: null,
    walletConnectingStatus: "disconnected",
  };
  const { useGlobalState } = createGlobalState(initialState);

export default useGlobalState;